var videoPlayButton,
    videoWrapper = document.getElementsByClassName('video-wrapper1')[0],
    video = document.getElementsByTagName('video')[0],
    videoMethods = {
        renderVideoPlayButton: function () {
            if (videoWrapper.contains(video)) {
                this.formatVideoPlayButton();
                video.classList.add('has-media-controls-hidden');
                videoPlayButton = document.getElementsByClassName('video-overlay-play-button')[0];
                videoPlayButton.addEventListener('click', this.hideVideoPlayButton);
            }
        },

        formatVideoPlayButton: function () {
            videoWrapper.insertAdjacentHTML('beforeend',
                `<div class="video-overlay-play-button"></div>`
            );
        },

        hideVideoPlayButton: function () {
            video.play();
            videoPlayButton.classList.add('is-hidden');
            video.classList.remove('has-media-controls-hidden');
            video.setAttribute('controls', 'controls');
        }
    };

videoMethods.renderVideoPlayButton();
